import { createFileRoute } from '@tanstack/react-router';
import { AboutCategoriesPage } from '@pages/about';

/** Über-uns-Kategorien-Übersicht (/about) — Verwaltet alle CMS-Kategorien */
export const Route = createFileRoute('/_authenticated/about/')({
  component: AboutCategoriesPage,
});
